export default __webpack_public_path__ + "images/03db2b7417ffe09b3b5e313beae65231.svg";